export const DEFAULT_LANGUAGE = 'en';

export const LANGUAGES = [DEFAULT_LANGUAGE, 'it', 'de'];

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
